"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getBrowserLocale;

function getBrowserLocale() {
  return navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage || 'en-US';
}